/**
 * 批阅信息
 */
import React from 'react';
import { component_tool } from '@/tool'
import { Mentions } from 'antd'
const { WizComponent, WizRow, WizCol, WizTypography } = component_tool;
const { Title, Paragraph } = WizTypography

import './index.less'

let questionTypeEnum = {
  0: "单选题",
  1: "多选题",
  2: "判断题",
  3: "填空题",
  4: "主观题",
  6: "文件上传题",
  7: "排序题",
}

export default class ReviewInfo extends WizComponent {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    _renderInfo() {
        let { data } = this.props
        if (data.length === 0) {
            return []
        }
        let items = data.map((item, i) => {
            return this._infoItem(item, i + 1)
        })
        return items
    }

    _infoItem(item, index) {
        /**
        * score 单题分
        * size 题目数量
        * title 章节标题 string
        * questions 题目信息 arr
        */
        let { score, size, title, questions, id: keyId, description } = item
        let titleMsg = `${index}.${title}(共${size}题, 每题${score}分, 共${size * score}分)`
        return (
            <div className='info-item' key={keyId}>
                <div className='review-chapter'>{titleMsg}</div>
                <div className='review-chapter-description' dangerouslySetInnerHTML={{__html: description}}/>
                {
                    questions.map((e, i) => {
                        let { title: qTitle, id, answer, obtainScore, img, type } = e

                        let _answer = answer
                        if(type === 6 && answer) {
                            _answer = <a type={'link'} onClick={() => answer && window.open(getOssFilePath(answer))}>查看</a>
                        }
                        return (
                            <div className='review-subject' key={id}>
                                <WizRow type='flex' gutter={16}>
                                    <WizCol span={18}>
                                        <Title className='review-subject-title'>
                                            <span className='title-block-style'>{i + 1}</span>
                                            <span className='title-block-type-style'>[{questionTypeEnum[type] || '未知'}]</span>
                                            {qTitle}
                                        </Title>
                                    </WizCol>
                                    <WizCol span={6}>
                                        <div className='subject-right-style'>
                                            <Mentions className='subject-right-input' readOnly defaultValue={obtainScore >= 0 ? obtainScore === 0 ? '0' : obtainScore : ''} />
                                            <span>分</span>
                                        </div>
                                    </WizCol>
                                </WizRow>
                                {
                                    img ? <img src={getOssFilePath(img)} className='img-style' /> : null
                                }
                                <div className='answer-style'>
                                    <div className='answer-left-font'>
                                        学员答案 ：
                                    </div>
                                    <Paragraph className='review-subject-info'>
                                        {_answer || '无'}
                                    </Paragraph>
                                </div>
                            </div>
                        )

                    })
                }
            </div>
        )
    }

    render() {
        return (
            <>
                {this._renderInfo()}
            </>
        )
    }

}
